import script from "./MyTicketsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTicketsView.vue?vue&type=script&setup=true&lang=js"

import "./MyTicketsView.vue?vue&type=style&index=0&id=6dad3b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dad3b10"]])

export default __exports__